// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const validatePresent = <T>(value?: T) => {
  if (Array.isArray(value) && value.length === 0) {
    return 'Field is required';
  }
  return value === null || value === undefined || value === '' ? 'Field is required' : undefined;
};
